export const unauthorizedErrorName = 'UnauthorizedError';
export const unauthorizedMessage = 'Unauthorized';

export class UnauthorizedError extends Error {
  name = unauthorizedErrorName;

  constructor(message?: string) {
    super(message ? `${unauthorizedMessage}: ${message}` : unauthorizedMessage);
  }
}
